module.exports = __webpack_public_path__ + "static/img/gongzhonghao.666365c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/gongzhonghao.jpg
// module id = 8zk3
// module chunks = 1